import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { ValueTable, ValueTableRow } from '@kerfjs/ui/value-table';
import type { SafeHtml } from 'kerfjs';
import { Pencil } from 'lucide';

import { effectiveFxRates } from '../../../../../../shared/fx-rates.js';
import { demandReadOnly } from '../../../../../lib/context.js';
import { orderedCurrencyCodes } from '../../../../../lib/currencies.js';
import { AssumptionsDialog } from '../../assumptions-dialog.js';

/** Editable rates and duties for the selected pricing check. */
export function OverviewAssumptionsSection({
  assumptions,
  base,
}: {
  assumptions: Record<string, unknown>;
  base: string;
}): SafeHtml {
  const valueOf = (key: string): string => {
    const value = assumptions[key];
    return typeof value === 'number' || typeof value === 'string' ? String(value) : '';
  };
  const fxRates = effectiveFxRates(assumptions);
  const fxCodes = orderedCurrencyCodes(new Set(['USD', 'CNY', ...Object.keys(fxRates)]));
  return (
    <>
      <List>
        {demandReadOnly() ? (
          <ListHeader label="Assumptions" />
        ) : (
          <ListHeader
            label="Assumptions"
            action="edit-analysis-assumptions"
            actionLabel="Edit Assumptions…"
            actionIcon={<LucideIcon icon={Pencil} name="" />}
          />
        )}
        <ValueTable label="Assumptions">
          {fxCodes.map((code) => (
            <ValueTableRow label={`${code}→${base}`} value={String(fxRates[code] ?? '—')} />
          ))}
          <ValueTableRow label="Duty % · AI" value={valueOf('customsDutyPct') || '—'} />
          <ValueTableRow label="Tax %" value={valueOf('salesTaxPct') || '—'} />
          <ValueTableRow label="Inland" value={valueOf('inlandFreight') || '—'} />
        </ValueTable>
      </List>
      <AssumptionsDialog />
    </>
  );
}
